export default "__VITE_ASSET__CuBjapeG__"